import Terms from 'components/common/Terms';
import {validateTerms} from 'function/validate';
import {IRegisterInfo} from 'pages/Register';
import React, {useEffect, useState} from 'react';

/**
 * 등록 약관 컴포넌트의 Props 인터페이스
 * @property {IRegisterInfo} registerInfo - 등록 정보
 * @property {React.Dispatch<React.SetStateAction<IRegisterInfo>>} setRegisterInfo - 등록 정보 설정 함수
 * @property {React.Dispatch<React.SetStateAction<boolean>>} setEnableButton - 버튼 활성화 상태 설정 함수
 */
interface props {
  registerInfo: IRegisterInfo;
  setRegisterInfo: React.Dispatch<React.SetStateAction<IRegisterInfo>>;
  setEnableButton: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * 등록 약관 컴포넌트
 * 등록 시 약관 동의를 처리하는 컴포넌트입니다.
 * @param {props} props - 등록 약관 컴포넌트의 props
 * @returns {JSX.Element} 등록 약관 컴포넌트
 */
export default function RegisterTerms({
  registerInfo,
  setRegisterInfo,
  setEnableButton,
}: props) {
  // 에러 메시지
  const [errorTexts, setErrorTexts] = useState({
    service: '',
    privacy: '',
    location: '',
  });

  useEffect(() => {
    const asyncFunc = async () => {
      const errorMsg = await validateTerms({
        values: registerInfo,
        setErrorTexts,
      });

      if (
        registerInfo.service &&
        registerInfo.privacy &&
        registerInfo.location &&
        errorMsg === ''
      ) {
        setEnableButton(true);
      } else {
        setEnableButton(false);
      }
    };
    asyncFunc();
  }, [registerInfo]);

  return (
    <>
      <Terms
        value={{
          service: registerInfo.service,
          privacy: registerInfo.privacy,
          location: registerInfo.location,
        }}
        setValue={setRegisterInfo}
      />
    </>
  );
}
